import { render } from "./Widget6.vue?vue&type=template&id=295bbf14"
import script from "./Widget6.vue?vue&type=script&lang=ts"
export * from "./Widget6.vue?vue&type=script&lang=ts"
script.render = render

export default script